<template>
    <BaseDialog :close-on-mask="closeOnMask" @reject="onClose">
        <div class="video-dialog u-dialog">
            <div class="dialog-content">
                <div class="u-btn close" @click="onClose"></div>
                <div id="playCon">
                    <iframe :src="`https://dhvod.17m3.com/4.2.1/player.html?vid=${vid}`" allow="autoplay" allowfullscreen="true" frameborder="0" scrolling="no" class="video-iframe" width="100%" height="100%"></iframe>
                </div>
            </div>
        </div>
    </BaseDialog>
</template>
<script>
import BaseDialog from '../BaseDialog.vue'

export default {
    name: 'VideoDialog',
    components: {
        BaseDialog,
    },
    props: {
        closeOnMask: {
            type: Boolean,
            default: true
        },
        vid: {
            type: String,
            default: ''
        }
    },   
    methods: {
        onClose() {
            this.$emit('resolve', false)
        },
    }
}
</script>

<style lang="scss" scoped>
.video-dialog{
    display: flex;
    justify-content: center;
    align-items: center;    
}

#playCon {
    position: relative;
    width: 100%;
    height: 0;
    padding-top: 56.25%;
}

.video-iframe {
    display: block;
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
}


@include responseTo('desktop') {
    .video-dialog {
        width: 1073px;
        height: 613px;
        background-image: url(~@/assets/images/modal/bg-modal-video_pc.png);
    }

    .dialog-content{
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 998px;
        height: 560px;
        box-sizing: border-box;
        margin-left: 16px;
        margin-top: 4px;        
    }
    
    .u-btn.close{
        right: -60px;
        top: -50px;
    }
}

@include responseTo('phone') {
    .video-dialog {
        width: 783px;
        height: 448px;
        background-image: url(~@/assets/images/modal/bg-modal-video_app.png);
    }

    .dialog-content{
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 720px;
        height: 405px;
        box-sizing: border-box;
        margin-left: 16px;
        margin-top: 4px;         
    }
    
    .u-btn.close{
        right: auto;
        left: 50%;
        top: 105%;
        transform: translateX(-50%);
        width: 46px;
        height: 46px;
        background-image: url(~@/assets/images/modal/btn-modal-close_video.png);
    }    
}
</style>